import React from 'react';
import styles from './LandingPage5.module.css';

import RobotIcon from '../../../../Images/newLandingPage/51.png';
import CrmIcon from '../../../../Images/newLandingPage/52.png';
import RoutingIcon from '../../../../Images/newLandingPage/53.png';
import AnalyticsIcon from '../../../../Images/newLandingPage/54.png';
import LanguageIcon from '../../../../Images/newLandingPage/55.png';
import crm from "../../../../Images/newLandingPage/5CRM.png";

const LandingPage5 = () => {
  const features = [
    {
      id: "01",
      icon: RobotIcon,
      title: "AI Call Automation",
      desc: "Natural-sounding AI handles inbound and outbound calls with human-like intelligence."
    },
    {
      id: "02",
      icon: CrmIcon,
      title: "Built-In CRM",
      desc: "All leads automatically organized with contact details and call history."
    },
    {
      id: "03",
      icon: RoutingIcon,
      title: "Smart Call Routing",
      desc: "Intelligently route calls to AI, team members, or departments based on rules."
    },
    {
      id: "04",
      icon: AnalyticsIcon,
      title: "Real-Time Analytics",
      desc: "Track outcomes, customer sentiment, and agent performance in real-time."
    },
    {
      id: "05",
      icon: LanguageIcon,
      title: "Multilanguage Support",
      desc: "Communicate with customers in their preferred language with 50+ languages supported."
    }
  ];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.headerCard}>
            <h2 className={styles.title}>
              Powerful Features That <br />
              <span className={styles.gradientText}>Drive Results</span>
            </h2>
            <p className={styles.subtitle}>
              Supercharge your business with tools designed for growth, efficiency, and scale.
            </p>
          </div>

          {features.map((feature) => (
            <div key={feature.id} className={styles.feature}>
              <div className={styles.iconCircle}>
                <span className={styles.number}>{feature.id}</span>
                <img src={feature.icon} alt={feature.title} className={styles.featureIcon} />
              </div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDesc}>{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className={styles.integration}>
          <div className={styles.integrationText}>
            <h2 className={styles.integrationTitle}>
              Works with Your <br />
              <span className={styles.highlight}>Existing Tools</span>
            </h2>
            <p className={styles.integrationDesc}>
              Seamlessly connects with major CRMs and business apps to keep your workflow unified.
            </p>
          </div>
          <div className={styles.integrationLogos}>
            <img src={crm} alt="Integrations" className={styles.logo} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPage5;
